import { Content } from "antd/lib/layout/layout";
import { Col, Row, Typography } from "antd";
import { motion } from "framer-motion";
import LazyLoad from "react-lazyload";
import YouTube from "react-youtube";

// Components
import { AffixWebDev } from "../components/AffixVideographer";
import Profile from "../components/Profile";
import Helmet from "../components/Helmet";
import CustomFooter from "../components/FooterCustom";

// Styles & Data
import style from "../components/Affix.module.css";
import projects from "../data/projects_video.json";

const { Title } = Typography;

// ✅ YouTube ID parser (handles /watch?v=, /shorts/, and youtu.be/)
const getYoutubeId = (url) => {
  if (!url) return null;
  try {
    if (url.includes("watch?v=")) return url.split("v=")[1]?.split("&")[0];
    if (url.includes("youtu.be/"))
      return url.split("youtu.be/")[1]?.split("?")[0];
    if (url.includes("/shorts/"))
      return url.split("/shorts/")[1]?.split("?")[0];
    return null;
  } catch {
    return null;
  }
};

// ✅ Group projects by type (don’t filter show:true yet, so you can see results)
const groupedProjects = projects.reduce((acc, project) => {
  const type = project.pjtype || "Uncategorized";
  if (!acc[type]) acc[type] = [];
  acc[type].push(project);
  return acc;
}, {});

// Helper: format section titles
const formatTitle = (type) => {
  if (!type) return "Uncategorized";

  // Manual mappings for special cases
  const map = {
    COMPANYPROFILE: "Company Profile",
    PV: "Promotional Video",
    SOCMED: "Social Media",
    DOCUMENTARY: "Documentary",
    EVENT: "Event",
  };

  // Return mapped title if exists
  if (map[type.toUpperCase()]) return map[type.toUpperCase()];

  // Else: convert snake_case / UPPERCASE to Title Case
  return type
    .toLowerCase()
    .split(/[\s_-]+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

const VideographerPortofolio = () => {
  return (
    <div>
      <AffixWebDev />
      <Content>
        <Helmet />
        <Profile displaycaption={false} />

        <motion.div
          className={style.videoportolayout}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ease: "easeIn", duration: 0.8 }}
        >
          <h2>My Portfolio</h2>

          {/* Debug notice */}
          {/* <p style={{ color: "yellow" }}>
            Loaded {projects.length} projects into {Object.keys(groupedProjects).length} sections
          </p> */}

          {Object.keys(groupedProjects).map((type) => (
            <div key={type} style={{ marginBottom: "60px" }}>
              <Title
                level={2}
                style={{
                  marginBottom: "30px",
                  textAlign: "center",
                  color: "white",
                }}
              >
                {formatTitle(type)}
              </Title>

              <Row gutter={[24, 24]} justify="center">
                {groupedProjects[type].map((val, i) => {
                  const videoId = getYoutubeId(val.url);

                  return (
                    <Col
                      key={i}
                      xs={24}
                      sm={12}
                      md={8}
                      lg={groupedProjects[type].length > 3 ? 6 : 8}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div>
                        {/* <h4 style={{ color: "white" }}>
                          {val.projectname} - {val.year}
                        </h4> */}
                        {videoId ? (
                          <LazyLoad height={400} offset={0} once>
                            <YouTube
                              videoId={videoId}
                              opts={{
                                width: "350",
                                height: "300",
                                playerVars: { modestbranding: 1, rel: 0 },
                              }}
                            />
                          </LazyLoad>
                        ) : (
                          <p style={{ color: "red" }}>
                            ❌ No videoId from URL: {val.url}
                          </p>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          ))}
        </motion.div>

        <CustomFooter />
      </Content>
    </div>
  );
};

export default VideographerPortofolio;
